export default __webpack_public_path__ + "static/media/countertuesday.97de2c4f.png";